import { LocalesEnum } from '@/enums/locales.enum';
import { SelectOption } from '@/types/form.types';

import i18n from '@/dependencies/i18n';
import { useUserStore } from '@/stores/user.store';
import userService from '@/services/user.service';
import storageService from '@/services/storage.service';
import { getParameterByName } from '@/helpers/utility.helper';

const { t } = i18n.global;

export default {
    constants: {
        DEFAULT: LocalesEnum.NL,
        storageKey: 'FIRM24_LOCALE',
    },

    languages: [
        {
            code: LocalesEnum.NL,
            label: t('ADMIN_SETTINGS.OPTIONS.DUTCH'),
            full: t('GLOBAL.DUTCH'),
            default: true,
        },
        {
            code: LocalesEnum.EN,
            label: t('ADMIN_SETTINGS.OPTIONS.ENGLISH'),
            full: t('GLOBAL.ENGLISH'),
            default: false,
        },
    ],

    get options(): SelectOption[] {
        return this.languages.map(
            (language: any): SelectOption => ({
                name: language.label,
                id: language.default,
            }),
        );
    },

    getQueryStringLanguage(): string {
        const userStore = useUserStore();
        const locale = this.normaliseUserLanguage(getParameterByName('locale'));

        if (locale) {
            if (userStore.session?.user?.id) {
                userService.updateUser({ locale });
                userStore.updateUserLocale(locale);
            }

            history.replaceState(null, '', window.location.pathname);
        }

        return locale ?? '';
    },

    getLocalStorageLanguage() {
        return storageService.get(this.constants.storageKey);
    },

    normaliseUserLanguage(language?: string | null): LocalesEnum | undefined {
        if (!language) {
            return;
        }

        return language.startsWith('en') ? LocalesEnum.EN : LocalesEnum.NL;
    },

    getUserLanguage(): string {
        const userStore = useUserStore();
        return [this.getQueryStringLanguage(), userStore.session?.user?.locale, this.getLocalStorageLanguage(), this.constants.DEFAULT].find(
            (value) => !!value,
        );
    },

    setLocaleLanguage(value: string) {
        storageService.set(this.constants.storageKey, value);
    },

    // Triggered as soon as we check for the session check for the URL as well when user authenticates
    setUserLanguage(): void {
        const locale = this.normaliseUserLanguage(this.getUserLanguage());

        if (locale) {
            i18n.global.locale.value = locale as any;
            this.setLocaleLanguage(locale);
        }
    },
};
